export const HOTEL_FEATURES_STAGE_ID = 21;
export const HOTEL_FEATURES_PROD_ID = 17;

export const HONEYMOON_FEATURES_STAGE_ID = 22;
export const HONEYMOON_FEATURES_PROD_ID = 21;

export const LOCATION_FEATURES_STAGE_ID = 24;
export const LOCATION_FEATURES_PROD_ID = 23;

export const REWARD_FEATURES_STAGE_ID = 25;
export const REWARD_FEATURES_PROD_ID = 24;

export const PET_ACCEPTANCE_FEATURES_STAGE_ID = 26;
export const PET_ACCEPTANCE_FEATURES_PROD_ID = 25;
